export { default as Categories } from './Categories';
export { default as Courses } from './Courses';
export { default as Hero } from './Hero';
export { default as PromoNumbers } from './PromoNumbers';
export { default as Reviews } from './Reviews';
export { default as Subscription } from './Subscription';
